module.exports = "pegasus/assets/theme6/medium/1.jpg";